import React, { useEffect, useState } from 'react'
import { HttpClient } from '../../../api/httpClient'

const EdiResponse = ({ responseId }) => {

    const [response, setResponse] = useState({ edi: [], columns: 0 })
    const [isLoading, setLoading] = useState(false)

    const getResponse = async () => {
        try {
            setLoading(true)
            const data = {
                eventMessage: { responseId },
                eventType: "GET_CCS_RESPONSE_BY_ID",
                eventTime: Date.now()
            }
            const res = await HttpClient.post(data)

            let rawEdiResponseStringArray = res?.data?.eventMessage?.ccsTransactionResponse?.[0]?.rawEdiResponseString ?? []
            let max = 0
            rawEdiResponseStringArray.forEach((itm) => {
                max = Math.max(max, itm.values?.[0]?.length)
            })
            setResponse({ edi: rawEdiResponseStringArray, columns: Array.from({ length: max + 2 }, (_, i) => i) })

        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (responseId)
            getResponse()
    }, [responseId])

    return (
        <div className='res-table-wrap'>
            {isLoading && <div>Loading...</div>}
            {(!!response?.edi?.length && !!response.columns.length && !isLoading )&& (
                <table className='res-table'>
                    <thead>
                        {response.columns.map((index) => {
                            let seq = index
                            seq = seq % 10 === 0 ? seq : String(seq).charAt(String(seq).length - 1)
                            return <th key={index}>{index === 0 ? " " : seq}</th>
                        })}
                    </thead>
                    <tbody>
                        {response.edi.map((tData, rowIndex) => {
                            return <tr key={rowIndex}>
                                {response.columns.map((_, columnIndex) => (
                                    <td key={columnIndex} className={columnIndex === 0 ? "rowcounter" : ""}>
                                        {columnIndex === 0 ?
                                            rowIndex + 1
                                            : tData.values[0][columnIndex - 1] ? tData.values[0][columnIndex - 1] : " "}
                                    </td>
                                ))}
                            </tr>
                        })}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default EdiResponse